import { isDefined } from '@/utils/assertions';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type Doc = {
  status: QueuedStatus;
  refId?: string;
};

type InitialState = {
  queuedDocuments: Record<string, Doc>;
};

const initialState: InitialState = {
  queuedDocuments: {},
};

export type QueuedStatus = 'waiting' | 'generated' | 'error';

export const documentToastSlice = createSlice({
  name: 'documentToastSlice',
  initialState,
  reducers: {
    addDocumentInQueue: (
      state,
      {
        payload: { status, refId, docId },
      }: PayloadAction<{ docId: string; status: QueuedStatus; refId?: string }>,
    ) => {
      state.queuedDocuments = {
        ...state.queuedDocuments,
        [docId]: { status, refId },
      };
    },
    updateDocumentInQueue: (
      state,
      {
        payload: { status, refId, docId },
      }: PayloadAction<{ docId: string; status: QueuedStatus; refId?: string }>,
    ) => {
      const queuedDocument = state.queuedDocuments[docId];
      if (isDefined(queuedDocument)) {
        queuedDocument.status = status;
      }
    },

    removeDocumentInQueue: (state, { payload: docId }: PayloadAction<string>) => {
      delete state.queuedDocuments[docId];
    },
  },
  selectors: {
    selectQueuedDocuments: (state) => state.queuedDocuments,
    selectGeneratedDocuments: (state) =>
      Object.entries(state.queuedDocuments).filter(
        ([_docId, queuedDocument]) => queuedDocument.status === 'generated',
      ),
    selectWaitingDocuments: (state) =>
      Object.entries(state.queuedDocuments).filter(
        ([_docId, queuedDocument]) => queuedDocument.status === 'waiting',
      ),
  },
});

export const { selectGeneratedDocuments, selectWaitingDocuments, selectQueuedDocuments } =
  documentToastSlice.selectors;
export const { addDocumentInQueue, removeDocumentInQueue, updateDocumentInQueue } =
  documentToastSlice.actions;
